const selectors = {
  modal: '#tc-enrollment-modal',
  modalOpen: '[data-tc-modal-open]',
  modalClose: '[data-tc-modal-close]',
  enrollmentForm: '#tc-enrollment-form',
  enrollmentSuccess: '[data-tc-enrollment-success]',
  accordion: '[data-tc-accordion]',
  firstCashback: '[data-tc-first-cashback]',
  postPurchase: '[data-tc-post-purchase]',
  dismiss: '[data-tc-dismiss]',
};
const STORAGE_KEY = 'tc_post_purchase_dismissed';

class TreasureClub {
  constructor() {
    this._modal = document.querySelector(selectors.modal);
    this._initModal();
    this._initEnrollment();
    this._initAccordions();
    this._initFirstCashback();
    this._initPostPurchase();
  }

  _initModal() {
    if (!this._modal) return;
    document.querySelectorAll(selectors.modalOpen).forEach((btn) => {
      btn.addEventListener('click', () => this._openModal());
    });
    this._modal.querySelectorAll(selectors.modalClose).forEach((el) => {
      el.addEventListener('click', () => this._closeModal());
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this._modal && !this._modal.hidden) this._closeModal();
    });
  }

  _openModal() {
    if (!this._modal) return;
    this._modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  _closeModal() {
    if (!this._modal) return;
    this._modal.hidden = true;
    document.body.style.overflow = '';
  }

  _initEnrollment() {
    const form = document.querySelector(selectors.enrollmentForm);
    if (!form) return;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      if (submit && submit.disabled) return;
      if (submit) submit.disabled = true;
      try {
        const response = await fetch(form.action, { method: 'POST', body: new FormData(form) });
        if (!response.ok) throw new Error(`Enrollment failed: ${response.status}`);
        form.hidden = true;
        const success = document.querySelector(selectors.enrollmentSuccess);
        if (success) success.hidden = false;
      } catch (err) {
        if (submit) submit.disabled = false;
      }
    });
  }

  _initAccordions() {
    const triggers = document.querySelectorAll(selectors.accordion);
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
        triggers.forEach((other) => {
          other.setAttribute('aria-expanded', 'false');
          const panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.style.maxHeight = '';
        });
        if (!wasOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          const panel = document.getElementById(trigger.getAttribute('aria-controls'));
          if (panel) panel.style.maxHeight = `${panel.scrollHeight}px`;
        }
      });
    });
  }

  _initFirstCashback() {
    const element = document.querySelector(selectors.firstCashback);
    if (!element) return;
    element.classList.add('tc-celebrate');
    element.addEventListener('animationend', () => element.classList.remove('tc-celebrate'), { once: true });
  }

  _initPostPurchase() {
    const prompt = document.querySelector(selectors.postPurchase);
    if (!prompt) return;
    if (sessionStorage.getItem(STORAGE_KEY)) {
      prompt.hidden = true;
      return;
    }
    const dismiss = prompt.querySelector(selectors.dismiss);
    if (!dismiss) return;
    dismiss.addEventListener('click', () => {
      prompt.hidden = true;
      sessionStorage.setItem(STORAGE_KEY, '1');
    });
  }
}
document.addEventListener('DOMContentLoaded', () => new TreasureClub());
